/** What the reading pane shows before anything is selected. */
export function EmptyPane() {
  return (
    <div className="read">
      <div className="empty">
        <p>Select a situation.</p>
        <p className="hint">
          The index lists what the pipeline has assembled, grouped by how far each
          separation has progressed.
        </p>
      </div>
    </div>
  );
}
